export default __webpack_public_path__ + "static/media/26.70fd3c5f.jpg";